<template>
  <div class="newHeader">
    <div>
      <a @click="toIndex">
        <img src="../assets/img/index/logo_head.png" alt />
      </a>
      <!-- <div class="personal" style>
          <a href="#">个人中心</a>
      </div>-->
      <div class="login-ent  already" v-if="docName!=''">
        <!-- <div class="login-ent" v-if="false"> -->
        <a @click="logout()">
          <span>退出</span>
        </a>
        <a @click="toAdmin">
          <span style="white-space: nowrap; overflow: visible">
            欢迎您&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="color-blue">{{docName}}</span>
          </span>
        </a>
      </div>
      <!-- <div class="login-ent" v-if="false"> -->
      <div class="login-ent" v-else>
        <!-- <a @click="$router.push({path:'/login',query:{from:2}})">
            <span>注 册</span>
        </a>-->
        <a @click="toLogin">
          <span>登 录</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      docName: ""
    };
  },
  methods: {
    // 跳转首页
    toIndex(){
      let url = window.location.protocol + '//' +  window.location.host
      window.location.href = url + '/index.html'

    },
    toAdmin() {
      let url = window.location.protocol + '//' +  window.location.host
      window.location.href = url + '/admin/index.html'

    },
    toLogin() {
      let url = window.location.protocol + '//' +  window.location.host
      window.location.href = url + '/login.html'
      // alert(window.location.href.split('#')[0] + '/login')
    },
    loginBtn() {
      let that = this;
      if (this.userName == "") {
        this.$message({
          message: "用户名为必填项！",
          type: "warning",
          offset: 300
        });
      } else if (this.password == "") {
        this.$message({
          message: "密码为必填项！",
          type: "warning",
          offset: 300
        });
      } else if (this.verifyCode == "") {
        this.$message({
          message: "验证码为必填项！",
          type: "warning",
          offset: 300
        });
      } else {
        this.loading = true;
        var params = new URLSearchParams();
        params.append("KEYDATA", that.userName + ",fjlzy," + that.password);
        params.append("verifyCode", that.verifyCode);
        params.append("sr_code", that.sr_code);
        that.$ajax
          .post("loginServer", params)
          .then(response => {
            this.loading = false;
            if (response.result == "success") {
              if (that.remember) {
                localStorage.setItem("userName", that.userName);
                localStorage.setItem("password", that.password);
              } else {
                localStorage.removeItem("userName");
                localStorage.removeItem("password");
              }
              that.docName = response.user.name;
              alert(that.docName);
              sessionStorage.setItem('sessionId', response.sessionId)
              alert(sessionId);
              // that.$common.setCookie('token',response.user.token,7)
              that.verifyCode = "";
            } else {
              this.$message({
                message: response.content,
                type: "error",
                offset: 300
              });
            }
          })
          .catch(error => {
            // alert(JSON.stringify(err/or));
            this.loading = false;
          });
      }
    },
     getOnline() {
      if (sessionStorage.getItem('sessionId')) {
        var params = new URLSearchParams();
        params.append("sessionId", sessionStorage.getItem('sessionId'));
        this.$ajax
          .post("getSessionIdIsExist", params)
          .then(response => {
            if (response.result) {
              this.docName = response.user.name;
              console.log('医生名字', this.docName)
            }
          })
          .catch(error => {});
      }
    },
    logout() {
      this.loading = true;
      var params = new URLSearchParams();
      params.append("sessionId", sessionStorage.getItem('sessionId'));
      this.$ajax
        .post("logout", params)
        .then(response => {
          this.loading = false;
          if (response.result) {
            this.docName = "";
            // alert("111--" + sessionId);
            sessionStorage.removeItem('sessionId');
            // this.$common.removeCookie("token");
          }
          this.codeBtn();
        })
        .catch(error => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getOnline();
    
  },
};
</script>

<style lang="stylus">
.newHeader
  height 64px
  background rgba(255, 255, 255, 0.8)
  color #fff
  z-index 99
  width 100%
  position fixed
  top 0
  >div
    width 1200px
    margin 0 auto
    img
      width auto
      height 48px
      float left
      margin-top 10px
    .login-ent
      a
        cursor pointer
        display inline-block
        float right
        height 64px
        width 140px
        line-height 64px
        color #000
        text-align center
        font-size 16px
        span
          display inline-block
          width 80px
          height 30px 
          font-size 14px
          font-weight 600
          // letter-spacing 3px
          cursor pointer
          border-radius 5px
          line-height 30px
          text-align center
          color #fff
          background rgb(51,153,255)
      &.already
        a
          color #ff0000
          span
            background none
            color #000
</style>